module.exports = __webpack_public_path__ + "/images/ico-cover-favicon-success.98731b2.svg";